import React, { useEffect } from 'react';
const Webinars = () => {
  useEffect(() => {
    window.location.href = 'https://aec.edu.in/competition/';
  }, [])
  return (
  <></>    
  )
}

export default Webinars;



